(function() {

    a3_cabin_reports.directive('trainingMenu', trainingMenu);

    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name ground Course List
     * @restrict E
     * @description
     *   Initialize navigation menu panel with with status indicators
     * @example
     *   Usage:
     *   <training-menu type="ground, crewroute, flight" id="groundDutyId, flightId" ></training-menu>
     * @ngInject
     */

    function trainingMenu(CourseFactory, GroundDutyFactory, FlightFactory, CrewRouteFactory, $location, TrainingSessionFactory, FlightSessionFactory, $filter, $routeParams) {
        function link($scope, attrs) {
            $scope.gotoCourse = gotoCourse;
            $scope.hasPendingTraining = false;
            $scope.hasUnsetTraining = false;

            var groundSessions = [];
            var flightSessions = [];
            TrainingSessionFactory.getAll(function(savedGroundSessions) {
                FlightSessionFactory.getAll(function(savedFlightSessions) {
                    groundSessions = savedGroundSessions;
                    flightSessions = savedFlightSessions;

                    $scope.courses = [];
                    var duty = null;
                    var dutyCourses = [];

                    if ($scope.type == 'ground') {
                        duty = GroundDutyFactory.getGroundDutyFromStorage($scope.id);
                        $scope.duty = duty;

                        if (duty && duty.RelatedGroundDuties) {
                            dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);
                            if (dutyCourses) {
                                CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId }), function(savedCourses) {
                                    manageGroundCourseStatuses(duty, dutyCourses, savedCourses);

                                    //Overall panel color
                                    if(savedCourses.some(x => x.Status == "Draft")){
                                        $scope.PanelClass="border-bottom-orange";
                                    }
                                    else if(savedCourses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
                                        $scope.PanelClass="border-bottom-blue";
                                    }
                                    else{
                                        $scope.PanelClass="border-bottom-green";
                                    }

                                    $scope.courses = savedCourses;
                                });
                            }
                        }
                    }
                    else if($scope.type == 'crewroute' || $scope.type == 'flight'){
                        if($scope.type == 'crewroute'){
                            duty = CrewRouteFactory.getCrewRouteFromStorage($scope.dutyNo, $scope.dutyDay);
                        }
                        else{
                            duty = FlightFactory.getFlightFromTotalFlights($scope.id);
                        }
                        if (duty && duty.Courses) {
                            dutyCourses = duty.Courses;
                            CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId }), function(savedCourses) {
                                dutyCourses.forEach(function(dutyCourse){
                                    var savedCourse = savedCourses.find(x => x.Id == dutyCourse.CourseId);
                                    if(savedCourse){
                                        var course = {
                                            Id: savedCourse.Id,
                                            Title : savedCourse.Title,
                                            Day: new moment(dutyCourse.Date)
                                        };
    
                                        manageFlightCourseStatus(course, dutyCourse);
                                        $scope.courses.push(course);
                                    }
                                    
                                });

                                $scope.courses.forEach(function(course){
                                    course.FullDate = course.Day.format("YYYY-MM-DD");
                                    course.Day = course.Day.format("DD/MM");
                
                                    if($scope.courses.filter(x => x.Id == course.Id).length>1){
                                        course.IsMultiday = true;
                                    }
                
                                });

                                //Overall panel color
                                if($scope.courses.some(x => x.Status == "Draft")){
                                    $scope.PanelClass="border-bottom-orange";
                                }
                                else if($scope.courses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
                                    $scope.PanelClass="border-bottom-blue";
                                }
                                else{
                                    $scope.PanelClass="border-bottom-green";
                                }
                            });
                        }
                    }
                   
                });
            });

            function manageFlightCourseStatus(course, crewRouteCourse){
                var now=moment.utc();
                var flights = FlightFactory.getFlightsFromStorage().filter(x => crewRouteCourse.TrainingFlightIds.includes(x.FlightId));
                flights = $filter('orderBy')(flights, 'ScheduledArrival');
                var dutyEnd = flights[flights.length-1].ScheduledArrival;

                var dutyDate =  new moment(crewRouteCourse.Date).format("YYYY-MM-DD");

                var status="";
                if(crewRouteCourse.Status == "Pending"){

                    //Pending
                    course.Status = "Pending";
                    course.StatusClass = "text-blue";
                        course.StatusDesc = "pending";
                    
                    //Outdated
                    dutyEnd = moment.utc(dutyEnd);
                    var duration = moment.duration(now.diff(dutyEnd)).asHours();
                    if(duration>1){
                        course.Status = "Outdated";
                    }

                    //Draft
					if(flightSessions && flightSessions.length > 0){
						var existingSession = flightSessions.find(s => s != null && s.courseId == crewRouteCourse.CourseId && s.day == dutyDate && s.dutyDay == $scope.dutyDay && s.dutyNo == $scope.dutyNo);
						if(existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length){
							//a training session with trainees exists
                            course.Status = "Draft"
                            course.StatusClass = "text-orange";
                            course.StatusDesc = "draft";
						}
					}
                }else if(crewRouteCourse.Status == "Completed"){
                    //Completed
                    course.Status = "Completed";
                    course.StatusClass = "text-green";
                    course.StatusDesc = "synced";
                }

                return status;
            }

            function manageGroundCourseStatuses(duty, dutyCourses, courses) {
                var now = moment.utc();

                courses.forEach(function(course) {
                    var dutyCourse = dutyCourses.find(x => x.CourseId == course.Id);
                    course.Status = dutyCourse.Status;

                    /*Statuses
                    	Completed : session has been sent
                    	Outdated  :	session submission is overdue
                    	Draft	  : session completion has started but not submitted
                    	Pending   : session submission not yet due
                    */

                    if (course.Status == "Pending") {
                        course.StatusClass = "text-blue";
                        course.StatusDesc = "pending";

                        //Outdated
                        var dutyEnd = moment.utc(duty.DutyEnd);
                        var duration = moment.duration(now.diff(dutyEnd)).asHours();
                        if (duration > 1) {
                            course.Status = "Outdated"
                        }

                        //Draft
                        if (groundSessions && groundSessions.length) {
                            var existingSession = groundSessions.find(s => s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id);
                            if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                                //a training session with trainees exists
                                course.Status = "Draft"
                                course.StatusClass = "text-orange";
                                course.StatusDesc = "draft";
                            }
                        }
                     
                    } else if (course.Status == "Completed") {
                        //Completed
                        course.Status = "Completed";
                        course.StatusClass = "text-green";
                        course.StatusDesc = "synced";
                    }
                });

                
            }

            /**
             * Redirect to Course Session
             */
            function gotoCourse(course) {
                if($scope.type=="ground"){
                    $location.path('/groundcourse/' + course.Id + '/' + $scope.duty.Id + "/" + $scope.duty.DutyDateS);
                }
                else if($scope.type=="crewroute"){
                    $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
                }
                else if($scope.type=="flight"){
                    $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId));
                }
            }
        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/training-menu.tpl.html",
            scope: {
                type: '@',
                id: '=',
                dutyNo: '=',
                dutyDay: '='
            },
            terminal: true,
            link: link
        }
    }
})();